import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconPickup = ({ t, fill, className, height, width }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    className={className}
    width={width}
    height={height}>
    <title>{t('Pickup')}</title>
    <g fill='none' fillRule='evenodd'>
      <rect width='100' height='100' rx='5' />
      <path d='M62.885 65.57a5.215 5.215 0 0 1-3.86 1.701H57.54v14.867c0 .908-.744 1.64-1.657 1.64a1.65 1.65 0 0 1-1.66-1.64V45.033c0-1.917 1.575-3.477 3.516-3.477 1.816 0 3.318 1.345 3.498 3.131l2.956 16.902a5.103 5.103 0 0 1-1.308 3.981zM52 55.489c0 2.843-2.415 5.154-5.389 5.154h-.116v21.491c0 .91-.766 1.644-1.718 1.644-.948 0-1.72-.734-1.72-1.644V60.643h-.113c-2.97 0-5.389-2.311-5.389-5.154V43.202c0-.91.771-1.646 1.723-1.646.947 0 1.716.736 1.716 1.646v8.886h2.063v-8.886c0-.91.772-1.646 1.72-1.646.952 0 1.718.736 1.718 1.646v8.886h2.067v-8.886c0-.91.768-1.646 1.717-1.646.95 0 1.721.736 1.721 1.646v12.287zm-8.947-39.908c.567-3.624 3.63-6.251 7.28-6.251 3.651 0 6.712 2.627 7.282 6.251l2.362 15.047H40.688l2.365-15.047zm32.76 17.822l2.85 57.305a2.952 2.952 0 0 1-.798 2.163 2.919 2.919 0 0 1-2.105.907H24.905a2.9 2.9 0 0 1-2.102-.907 2.938 2.938 0 0 1-.8-2.163l2.85-57.305a2.912 2.912 0 0 1 2.905-2.775h9.586l2.431-15.487C40.562 10.133 45.29 6 50.332 6c5.044 0 9.768 4.133 10.557 9.141l2.432 15.487h9.59a2.911 2.911 0 0 1 2.902 2.775zm-17.876 11.62a.2.2 0 0 0-.198-.19.202.202 0 0 0-.198.2V63.99h1.484c.541 0 1.037-.217 1.398-.615a1.82 1.82 0 0 0 .471-1.44l-2.957-16.912zM40.995 55.488c0 1.028.875 1.867 1.95 1.867h3.666c1.075 0 1.952-.84 1.952-1.867v-.111h-7.568v.11z'
        fill={fill} />
    </g>
  </svg>
)

export default Icon(IconPickup)
